var initSmaakwielInterface = function() {
    var currentType = initialType;
    var smaakwiel   = new Smaakwiel($('.smaakwiel-left .chart'), {
        smaken: smaken,
        datasetSwitches: '.datasets a',
        type: initialType,
        eigenSmaakwielen: eigenSmaakwielen
    });

    var $share = $('.smaakwiel-left .share');
    var showShare = false;

    if (eigenSmaakwielen[initialType] != undefined) {
        showShare = true;
        $share.slideDown();
    }

    $share.find('a').on('click', function(e) {
        e.preventDefault();
        // var url = 'https://www.facebook.com/share.php?u=' + smaakwielUrl + smaakwiel.getShareKey() + '/';
        // openWindow(url, 'share', 500, 400);
        downloadImage($(this).data('bg'));
    });

    $('.anchor-btn').on('click', function(e) {
        e.preventDefault();

        var href        = $(this).attr('href');
        var extraMargin = 0;

        setTimeout(function() {
            $('html, body').animate({scrollTop: $(href).offset().top + extraMargin}, 500, function() {
                $('body').addClass('scrolled');
                $('.navbar-fixed-top').removeClass('visible');
            });
        }, 10);
    });

    $('.btn-eigen').on('click', function(e) {
        $(this).slideUp();
        $('.smaakwiel-left').removeClass('focus');
        $('.smaakwiel-right').addClass('focus');
        $('.block.kenners').removeClass('block-show').addClass('block-hide');
        $('.block.eigen').removeClass('block-hide').addClass('block-show');

        if (initialType != '') {
            $('.datasets a[data-kenner-id=1]').trigger('append');
        }

        $share.slideUp();
    });

    $('.btn-kenners').on('click', function(e) {
        $(this).slideUp();
        $('.smaakwiel-left').removeClass('focus');
        $('.smaakwiel-right').addClass('focus');
        $('.block.eigen').removeClass('block-show').addClass('block-hide');
        $('.block.kenners').removeClass('block-hide').addClass('block-show');
    });

    $('.btn-toon').on('click', function(e) {
        $('.smaakwiel-right').removeClass('focus');
        $('.smaakwiel-left').addClass('focus');
        $('.btn-kenners').slideDown();
    });

    $('.btn-save-eigen').on('click', function(e) {
        var $btn = $(this);
        var $smaakwielRight = $('.smaakwiel-right');

        if ($smaakwielRight.hasClass('disabled')) {
            return false;
        }

        $smaakwielRight.removeClass('focus');
        $('.smaakwiel-left').addClass('focus');
        $('.btn-eigen').slideDown();

        $.post('/site/ajax/save_smaakwiel_vote.php', smaakwiel.getVoteData(), function(data) {
            if (data.error) {
                showAlert(data.error);
                return;
            }

            smaakwiel.setUserKey(data.user_secret_key);
            smaakwiel.setShareKey(data.share_key);
            $share.slideDown();
            showShare = true;

            if (initialType !== '') {
                // setTimeout(function() {
                //     $('.save-message').fadeIn();
                // }, 1000);

                $('.block.eigen').removeClass('block-show').addClass('block-hide');
                $('.block.kenners').removeClass('block-hide').addClass('block-show');
            } else {
                document.location = smaakwielen[currentType].url + '#saved';
            }
        });
    });

    $('.datasets a[data-kenner-id=1]').on('click', function() {
        if ($(this).data('smaakwiel').data.length == 0) {
            $('.btn-eigen').trigger('click');
        }
    });

    $('.datasets a').on('click', function() {
        var $btn = $(this);

        setTimeout(function() {
            var kennerId = $btn.data('kenner-id');
            var active   = $btn.hasClass('active');

            if (active) {
                if ($('.notitie[data-kenner-id=' + kennerId + ']').length > 0) {
                    $('.notitie[data-kenner-id=' + kennerId + ']').slideDown('fast');
                    $('.notities').slideDown('fast');
                }

            } else {
                $('.notitie[data-kenner-id=' + kennerId + ']').slideUp('fast', function() {
                    if ($('.notities').find('.notitie:visible').length == 0) {
                        $('.notities').slideUp('fast');
                    }
                });
            }
        }, 10);
    });

    $('.notitie > a').on('click', function(e) {
        e.preventDefault();
        $(this).parent().find('.extra').slideDown('fast');
        $(this).slideUp('fast');
    });

    if (initialType == '') {
        $('.choose-type a').on('click', function(e) {
            e.preventDefault();

            currentType = $(this).data('type');
            $('.choose-type a').removeClass('active');
            $(this).addClass('active');
            $('.smaakwiel-header h2').text(smaakwielen[currentType].title);

            $('.smaakwiel-right').removeClass('disabled');
            $(window).trigger('resize');

//                $('.smaakwiel-menu h2 a span').text(smaakwielen[currentType].title);
//            $('.smaakwiel-menu').css('visibility', 'visible');
//                $('.smaakwiel-menu li').removeClass('hidden');
//                $('.smaakwiel-menu a[data-type=' + currentType + ']').closest('li').addClass('hidden');

//            $('.choose-type').slideUp();
            smaakwiel.setType(currentType);
            $('.btn-eigen').trigger('click');
        });
    }

    if (document.location.hash == '#eigen') {
        $('.btn-eigen').trigger('click');
    }

    if (document.location.hash == '#saved') {
        // setTimeout(function() {
        //     $('.save-message').fadeIn();
        // }, 1000);
    }

    $(window).on('resize', function() {
        setTimeout(function() {
            var eigenHeight   = $('.block.eigen').outerHeight(true) || 0;
            var kennersHeight = $('.block.kenners').outerHeight(true) || 0;
            var rightHeight   = eigenHeight > kennersHeight ? eigenHeight : kennersHeight;

            $('.smaakwiel-right').css('min-height', rightHeight);
        }, 10);
    }).trigger('resize');

    // Vote van 'jouw vriend' laden
    $('.datasets a[data-kenner-id=3]').trigger('click');


    function dataURItoBlob(dataURI, mime) {
        var byteString = window.atob(dataURI);
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        var blob = new Blob([ia], { type: mime });
        return blob;
    }

    function downloadImage(backgroundSrc) {
        var destCanvas   = $('.smaakwiel-left .share-canvas')[0];
        var sourceImageData = $('.smaakwiel-left .chartjs-render-monitor')[0].toDataURL("image/png");
        var destCanvasContext = destCanvas.getContext('2d');
        var background = new Image();
        var resizeFactor = 2;

        background.src = backgroundSrc;
        background.onload = function(){
            destCanvasContext.drawImage(background,0, 0, 982 * resizeFactor, 982 * resizeFactor);
            var destinationImage = new Image;
            destinationImage.onload = function(){
                destCanvasContext.drawImage(destinationImage, -110 * resizeFactor, 220 * resizeFactor, 1200 * resizeFactor, 600 * resizeFactor);
            };
            destinationImage.src = sourceImageData;

            setTimeout(function() {
                var filename = "hertogjan-proeftuin-smaakwiel.jpg";
                var exportImageData = destCanvas.toDataURL("image/jpeg", 90);
                var imgdata = exportImageData.match(/data:(image\/.+);base64,(.+)/);
                var blob = dataURItoBlob(imgdata[2], imgdata[1]);
                var filesArray = [
                    new File([blob], filename, {
                        type: blob.type,
                        lastModified: new Date().getTime()
                    })
                ];

                // 240903: navigator.share alleen gebruiken op mobiele devices, want op mac os chrome werkt het niet
                if ($(window).width() <= 768 && navigator.canShare && navigator.canShare({ files: filesArray })) {
                    navigator.share({
                        files: filesArray
                    })
                    .then(function() { console.log('Share OK'); })
                    .catch(function(error) { console.log('Share failed', error); });

                } else {
                    var link = document.createElement('a');
                    link.download = filename;
                    link.href = exportImageData.replace("image/jpeg", "image/octet-stream");
                    link.click();
                }

            }, 400);
        }
    }
};
